import { List } from "immutable";
import * as actions from "./AdminTagActions";
import { AdminTagState, initialAdminTagState } from "./AdminTagState";
import buildReducer from "../../utils/ReducerBuilder";

export const AdminTagReducer = buildReducer<AdminTagState>(initialAdminTagState)
    .handle(actions.onTagsUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            tags: {
                data: (Array.isArray(action.payload) ? List(action.payload) : action.payload),
                loading: state.tags.loading,
                loadedOn: new Date().valueOf(),
            },
        };
    })
    .handle(actions.toggleLoadingTags, (state, action) => ({
        ...state,
        tags: {
            ...state.tags,
            loading: action.payload || false,
        },
    }))
    .done();



// WEBPACK FOOTER //
// ./src/store/adminTag/AdminTagReducer.ts